// hooks/useElementPositionRef.js
import { useState, useEffect, useRef } from 'react';

export const useElementPositionRef = () => {
    const [position, setPosition] = useState({ distanceFromTop: 0, isInViewport: false });
    const elementRef = useRef(null);

    useEffect(() => {
        const updatePosition = () => {
        if (!elementRef.current) return;

        const rect = elementRef.current.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const distanceFromTop = rect.top + scrollTop;
        
        setPosition({
            distanceFromTop,
            isInViewport: (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= window.innerHeight &&
            rect.right <= window.innerWidth
            )
        });
        };

        updatePosition();

        window.addEventListener('scroll', updatePosition);
        window.addEventListener('resize', updatePosition);

        return () => {
        window.removeEventListener('scroll', updatePosition);
        window.removeEventListener('resize', updatePosition);
        };
    }, []);

    return { elementRef, ...position };
};
